import {
  USER_LOAD_REQUEST,
  USER_LOAD_SUCCESS,
  USER_LOAD_FAILURE,
  UPDATE_USER_REPORTS_SUCCESS,
  UPDATE_USER_REPORTS_REQUEST,
  UPDATE_USER_REPORTS_FAILURE
} from '../types/user-types';

const initialState = {
  loading: false,
  success: false,
  error: null,
  user: null
};

function user(state = initialState, action: any = null) {
  switch (action.type) {
    case USER_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case USER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case USER_LOAD_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        success: true,
        error: null
      };

    case UPDATE_USER_REPORTS_SUCCESS:
      return {
        ...state,
        user: {
          // @ts-ignore
          ...state.user,
          permissions: {
            ...state.user.permissions,
            reports: action.payload
          }
        }
      };

    default:
      return state;
  }
}

export default user;
